<template>
  <v-container fluid>
    <v-row align="center" class="mb-5">
      <v-col md="12" sm="12">
        <h1 class="text-2xl">
          Monitoring
        </h1>
      </v-col>
    </v-row>
    <v-row class="pb-5 mb-10 border-bottom">
      <OnlinePayments/>
      <Sms/>
    </v-row>
    <v-row class="pb-5 mb-5 border-bottom">
      <Email/>
      <Queue/>
      <Cache/>
    </v-row>
    <v-row class="pb-5 mb-10 border-bottom">
      <CidStatus />
      <ICPLogs />
    </v-row>
<!--    <v-row class="mb-5 border-bottom">-->
<!--      <v-col md="12" sm="12">-->
<!--        <h2 class="text-xl">Payment Gateways</h2>-->
<!--      </v-col>-->
<!--      <PaymentGateways v-for="(pg,index) in paymentGateways" v-bind="pg" :key="index"/>-->
<!--    </v-row>-->
  </v-container>
</template>

<script>
import OnlinePayments from "@/components/Monitoring/OnlinePayments.vue";
import Sms from "@/components/Monitoring/Sms.vue";
import Email from "@/components/Monitoring/Email.vue";
import CidStatus from "@/components/Monitoring/CidStatus.vue";
import ICPLogs from "@/components/Monitoring/ICPLogs.vue";
// import PaymentGateways from "@/components/Monitoring/PaymentGateways.vue";
import Cache from "@/components/Monitoring/Cache.vue";
import Queue from "@/components/Monitoring/Queue.vue";

export default {
  components: {
    OnlinePayments,
    Email,
    Sms,
    Cache,
    ICPLogs,
    CidStatus,
    // PaymentGateways,
    Queue
  },
  data() {
    return {
      paymentGateways:[],
    }
  },
  mounted() {
    // this.getPaymentGateways();
  },
  methods: {
    getPaymentGateways() {
      this.loading = true; // Start loader
      this.$http
          .get(`monitoring/get-all-payment-gateways`)
          .then((response) => {
            if (response.status == 200) {
              this.paymentGateways = response.data.data;
            }
          })
          .catch((error) => {
            this.errorChecker(error);
          })
          .finally(() => {
            this.loading = false; // Stop loader
          });
    },
  }
}

</script>

<style scoped>

</style>